import {
	AfterViewInit,
	ChangeDetectorRef,
	Component,
	ElementRef,
	Inject,
	inject,
	OnInit,
	ViewChild,
	ViewEncapsulation,
} from '@angular/core';
import {
	FormBuilder,
	FormGroup,
	ReactiveFormsModule,
	Validators,
	AbstractControl,
	FormsModule,
} from '@angular/forms';
import {
	MAT_DIALOG_DATA,
	MatDialog,
	MatDialogRef,
} from '@angular/material/dialog';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { MatListModule } from '@angular/material/list';
import { MatTabsModule } from '@angular/material/tabs';
import { CommonModule, NgIf } from '@angular/common';
import {
	MatAutocompleteModule,
	MatAutocompleteSelectedEvent,
} from '@angular/material/autocomplete';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';

import { Observable, startWith, switchMap } from 'rxjs';


import { StoreOperationHoursDialogComponent } from './store-operation-hours/store-operation-hours.component';
import { EditOperationHoursComponent } from './edit-operation-hours/edit-operation-hours.component';
import { MessageService } from 'primeng/api';

import { MatDialogModule } from '@angular/material/dialog';
import { AddSpecialHoursDialogComponent } from './special-hours/add-dialog/add-special-hours-dialog.component';
import { EditSpecialHoursDialogComponent } from './special-hours/edit-dialog/edit-special-hours-dialog.component';
import { AppMaterialModule } from 'app/app-material.module';
import { AppDataService } from '../../../../services/app.data.service';
import { MerchantService, ProductService, StoreService } from 'app/services';
import { MerchantStoreItem } from 'app/components/merchant/partners-portal/types/merchant-store-item.type';
import { duplicateAddressValidator } from 'app/components/merchant/partners-portal/validators/duplicate-address.validator';
import { fileUploadValidator } from 'app/components/merchant/partners-portal/validators/file-upload.validator';
import { LocationType } from 'app/models';
import {
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle
} from '@angular/material/expansion';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { DialogModule } from 'primeng/dialog';
import { MatCardModule } from '@angular/material/card';
import {MatRippleModule} from '@angular/material/core';
import { PreparationHoursComponent } from './preparation-hours/preparation-hours.component';
import * as moment from 'moment';
import { Utils } from 'app/utils';
import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { ToastModule } from 'primeng/toast';
import { ComboItemDto } from 'app/merchant/partners-portal/interfaces/combo-item.interface';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { MerchantTypeEnum } from 'app/models/enums/lokal/merchant-type.enum';

// Interface for Step One form model
interface StepOneFormModel {
  Address: string;
  brand: string;
  StoreName: string;
  locType: string;
  addDetails: string;
  ImageUrl: string;
  StoreType: number;
}

// Interface for Step Two form model
interface StepTwoFormModel {
  fileupload: File[];
}

// Interface for time range
export interface TimeRange {
	hour: number;
	minute: number;
	period: 'AM' | 'PM';
	endHour: number;
	endMinute: number;
	endPeriod: 'AM' | 'PM';
	start: Date;
	end: Date;
	startTime: string;
	endTime: string;
}

// Interface for operating hours entry
export interface OperatingHoursEntry {
  operationHourId?: number | null; // Keep for backward compatibility
  operationHourIds?: number[]; // New property for multiple operation hour IDs
	selectedDays: string[];
	timeRanges: TimeRange[];
}

export interface specialHoursEntry {
	id?: number; // Add optional id property for backend operations
	availability: boolean;
	timeRanges: TimeRange[];
	open24hrs: boolean;
	startDate: Date;
	endDate: Date;
	description: string;
}

// Interface for store operation hours sent to backend
export interface StoreOperationHourDto {
	OperationHourId: number;
	DayOfWeek: number;
	StartTime: string;
	EndTime: string;
}

// Interface for Step Three form model
interface StepThreeFormModel {
	operationHours: OperatingHoursEntry[];
}

// Interface for Step Four form model
interface StepFourFormModel {
    MerchantId: number;
    Commission: number;
    MinimalOrderAmount: number;
    MinimalOrderFee: number;
}

interface CreateStoreFormModel {
  stepOne: StepOneFormModel;
  stepTwo: StepTwoFormModel;
  stepThree: StepThreeFormModel;
  stepFour: StepFourFormModel;
}
// TODO Create Request Model for Submitting for preview create store

@Component({
  selector: 'partner-mart-create-store-multistep',
  standalone: true,
    imports: [
        ReactiveFormsModule,
        MatStepperModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatAutocompleteModule,
        MatSelectModule,
        MatListModule,
        MatTabsModule,
        NgIf,
        MatChipsModule,
        CommonModule,
        MatDialogModule,
        MatAccordion,
        MatExpansionPanel,
        MatExpansionPanelHeader,
        MatExpansionPanelTitle,
        FormsModule,
        MatProgressSpinner,
        DialogModule,
        MatCardModule,
        MatRippleModule,
        MatRadioButton,
        MatRadioGroup,
        ToastModule
    ],
  templateUrl: './partner-mart-create-store-multistep.component.html',
  styleUrls: [
    './partner-mart-create-store-multistep.component.scss',
    '../../../../../styles/m3-defaul-material-theme.scss',
  ],
  providers: [MessageService],	encapsulation: ViewEncapsulation.None
})

export class PartnerMartCreateStoreComponent implements OnInit, AfterViewInit {
  dialogRef = inject(MatDialogRef<PartnerMartCreateStoreComponent>);
	isLinear = true;
  submitted = false;
  loading = false;
  createStoreForm!: FormGroup;
	streetOptions: string[] = [
		'Ayala Avenue',
		'Quezon Avenue',
		'Roxas Boulevard',
	];
  filteredStreets: string[] = [];
  editedStore!: MerchantStoreItem;
  selectedFileName: string | null = null;
  selectedFile: File | null = null;
  productFileValid: boolean = false;
	savedOperationHours: OperatingHoursEntry[] = [];
	saveSpecialHours: any[] = [];
  readonly locationTypeList = LocationType.LocationTypeList;

  createStoreDto: any = {};
  modalTitle: string = 'Create New Store';
  filesNames: string[] = [];
  formData: FormData = new FormData();

	showPrepTimeModal = false;
	prepTimeValue: string = '20 Minutes';
  prepTimeValueInt: number = 20;

  //step 4 - settings
  merchantsList: ComboItemDto[] = [];
  commissionDisplayValue: string = '';
  promoAdvertisingDisplayValue: string = '';
  amountDisplayValue: string = '';
  feeDisplayValue: string = '';

  //step 5 - preview
  showDetailsPreview: boolean = false;
  showProductsPreview: boolean = false;
  showStoreHoursPreview: boolean = false;
  showSettingsPreview: boolean = false;
  showConfirmCreation: boolean = false;
  previewOperationHours: string[] = [];
  merchantName: string | undefined = '';
  locationName: string = '';
  lat: number = 0;
  long: number = 0;
  storeTypeText: string = 'Eats';

  @ViewChild('stepper', { static: false }) stepper!: MatStepper;
  @ViewChild('hiddenFileInput') hiddenFileInput!: ElementRef<HTMLInputElement>;
  // ? Google Maps API variables
  @ViewChild('mapContainer') mapContainer!: ElementRef;
  filteredOptions$?: Observable<google.maps.places.AutocompletePrediction[]>;
  private map: google.maps.Map | undefined;
  private circle: google.maps.Circle | undefined;
  private autocompleteService:
    | google.maps.places.AutocompleteService
    | undefined;
  private placesService: google.maps.places.PlacesService | undefined;
  private geocoder?: google.maps.Geocoder;
  private currentMarker: google.maps.Marker | null = null;
  isStepperReady = false;

  constructor(
    private dialog: MatDialog,
    private fb: FormBuilder,
    private appData: AppDataService,
    private storeService: StoreService,
	private productService: ProductService,
    private messageService: MessageService,
    private merchantService: MerchantService,
    private cd: ChangeDetectorRef,
		@Inject(MAT_DIALOG_DATA)
		public data: {
      store: MerchantStoreItem;
      stores: MerchantStoreItem[];
    }
  ) {}

  ngAfterViewInit() {
    this.isStepperReady = true;
    this.cd.detectChanges();
  }

	ngOnInit(): void {
		this.createStoreForm = this.fb.group({
			stepOne: this.fb.group({
				Address: ['', Validators.required],
				Radius: [5, Validators.required],
				brand: ['', Validators.required],
				StoreName: ['', Validators.required],
                StoreEmailAddress: ['', [Validators.required, Validators.email]],
                StorePhoneNumber: ['', [Validators.required, Validators.pattern(/^(09|\+639)\d{9}$/)]],
                City: [''],
                PostalCode: [''],
				locType: ['', Validators.required],
				addDetails: ['', Validators.required],
                StoreType: [1, Validators.required],
				ImageUrl: ['', Validators.required]
			}),
			stepTwo: this.fb.group({
				fileupload: ['', Validators.required]
			}),
			stepThree: this.fb.group({
				operationHours: [[]]
			}),
			stepFour: this.fb.group({
				MerchantId: ['', Validators.required],
				Commission: [18, Validators.required],
				MinimalOrderAmount: [250, Validators.required],
				MinimalOrderFee: [50, Validators.required],
				PromoAdvertisingBudget: [{ value: 'Coming Soon', disabled: true }, Validators.required],
				PreparationTime: [this.prepTimeValueInt, Validators.required]
			}),
            stepFive: this.fb.group({
            }),
		});

		if (this.data?.store) {
			this.editedStore = this.data.store;
			this.stepOneForm.patchValue({
				Address: this.data.store.Address || '',
				Radius: this.data.store.Radius || '',
				brand: this.data.store.Brand || '',
                StoreEmailAddress: this.data.store.Email || '',
                StorePhoneNumber: this.data.store.Phone || '',
                City: this.data.store.City || '',
                PostalCode: this.data.store.PostalCode || '',
				StoreName: this.data.store.Name || '',
				locType: this.data.store.LocationTypeId?.toString() || '',
				addDetails: this.data.store.AddressDetails || '',
				ImageUrl: this.data.store.ImageUrl || ''
			});
		}

		this.stepOneForm.get('Address')?.valueChanges.subscribe(value => {
			if (!value?.place_id) {
				this.stepOneForm.get('Address')?.setErrors({ invalidAddress: true });
			}
		});

		this.setMaps();
		this.stepOneForm.get('Radius')?.valueChanges.subscribe(value => {
			this.updateRadius(value);
		});

		this.getMerchantsForCombo();
	}

    getMerchantsForCombo(): void {
        const dto = {
            IsLimitedByCurrentUser: true,
        };
        this.merchantService.getMerchantsForCombo(dto, this.messageService)
            .then(data => {
                if (data && data.length > 0) {
                    this.merchantsList = data;
                }
            })
            .catch(err => {
                throw err;
            });
    }

    onInput(event: Event) {
        const input = event.target as HTMLInputElement;

        const allowedChars = /[0-9.,]/;
        const inputChar = input.value;

        if (!allowedChars.test(inputChar)) {
            event.preventDefault();
        }
    }

    formatValue(event: Event, field: string = '') {
        const input = event.target as HTMLInputElement;
        let numericValue = input.value.replace(/[^0-9.,]/g, '');
        if (!parseFloat(numericValue)) {
            this.stepFourForm.get(field)?.setValue('', { emitEvent: false });
            return;
        }

        numericValue = parseFloat(numericValue).toFixed(2);
        numericValue = numericValue.replace(',', '.');
        this.stepFourForm.get(field)?.setValue(numericValue, { emitEvent: false });
        switch (field) {
            case 'Commission': this.setCommissionValue(numericValue); break;
            //case 'PromoAdvertisingBudget': this.promoAdvertisingDisplayValue = numericValue ? `${numericValue}` : ''; break;
            case 'MinimalOrderAmount': this.amountDisplayValue = numericValue ? `${numericValue}` : ''; break;
            case 'MinimalOrderFee': this.feeDisplayValue = numericValue ? `${numericValue}` : ''; break;
        }
    }

    setCommissionValue(numericValue: string) {
      const commission = parseFloat(numericValue);
      if (commission > 100) {
          this.commissionDisplayValue = '100%';
      } else {
          this.commissionDisplayValue = numericValue ? `${numericValue}%` : '';
      }
    }

  updateRadius(radius: number) {
    if (this.circle && radius > 0) {
      this.circle.setRadius(radius * 1000);
    }
  }

  private setMaps(): void {
    this.loadGoogleMapsApi().then(() => {
      this.initAutocompleteService();
      this.initMap();
      this.initGeocoder();
      this.filteredOptions$ = this.stepOneForm
        .get('Address')
        ?.valueChanges.pipe(
          startWith(''),
          switchMap((value) => this.filter(value || ''))
        );
      this.geocodeAddress();
      this.setStreetAddressValidator();
    });
  }

  private filter(
    value: string
  ): Observable<google.maps.places.AutocompletePrediction[]> {
    if (!value) {
      return new Observable((observer) => observer.next([]));
    }
    return new Observable((observer) => {
      this.autocompleteService?.getPlacePredictions(
        { input: value, componentRestrictions: { country: 'PH' } },
        (predictions, status) => {
          if (
            status === window.google.maps.places.PlacesServiceStatus.OK &&
            predictions
          ) {
            observer.next(predictions);
          } else {
            observer.next([]);
          }
        }
      );
    });
  }

	private loadGoogleMapsApi(): Promise<void> {
    return new Promise((resolve) => {
      if (window.google && window.google.maps) {
        resolve();
        return;
      }
    });
  }

	private initAutocompleteService(): void {
    this.autocompleteService =
      new window.google.maps.places.AutocompleteService();
    this.placesService = new window.google.maps.places.PlacesService(
      document.createElement('div')
    );
  }

	private initMap(): void {
    this.map = new window.google.maps.Map(this.mapContainer.nativeElement, {
      zoom: 15,
      center: { lat: 14.5995, lng: 120.9842 },
    });
  }

	private initGeocoder(): void {
    this.geocoder = new window.google.maps.Geocoder();
  }

  	private geocodeAddress(): void {
		if (!this.editedStore) {
			return;
		}

		if (!this.geocoder) {
			return;
		}

    this.geocoder.geocode(
      { address: this.editedStore.Address },
      (results, status) => {
        if (
          status === window.google.maps.GeocoderStatus.OK &&
          results &&
          results.length > 0
        ) {
          const location = results[0].geometry.location;
          this.map?.setCenter(location);
          this.map?.setZoom(11);
          this.currentMarker = new window.google.maps.Marker({
            map: this.map,
            position: location,
            title: this.editedStore.Address,
            draggable: false,
          });
          this.addMarkerListener(this.currentMarker);
        		} else {
			// Geocode was not successful
		}
      }
    );
  }

  displayFn(place: google.maps.places.AutocompletePrediction | string): string {
    if (place) {
      return typeof place === 'string' ? place : place.description;
    }

    return '';
  }

    onStepChange(event: StepperSelectionEvent): void {
        if (event.selectedIndex === 4) {
            this.goToPreview();
            if (event.selectedIndex < this.stepper.steps.length - 1) {
                this.stepper.next();
            }
        }
    }

    onMerchantSelected(event: MatSelectChange): void {
        this.merchantName = this.merchantsList.find(x => x.Id === event.value)?.Name;
    }

    onLocationTypeSelected(event: MatSelectChange): void {
        this.locationName = this.locationTypeList.find(x => x.value === event.value)?.name;
    }

  onOptionSelected(event: MatAutocompleteSelectedEvent): void {
    const selectedPlace = event.option.value;
    if (!this.validateDuplicateAddress(selectedPlace.description)) {
      this.stepOneForm.get('Address')?.setValue(selectedPlace);
    }

    this.placesService?.getDetails(
      { placeId: selectedPlace.place_id },
      (place, status) => {
        if (
          status === window.google.maps.places.PlacesServiceStatus.OK &&
          place &&
          place.geometry &&
          place.geometry.location
        ) {
          this.map?.setCenter(place.geometry.location);
          this.map?.setZoom(11);

            this.lat = place.geometry.location.lat();
            this.long = place.geometry.location.lng();

          if (this.currentMarker) {
            this.currentMarker.setPosition(place.geometry.location);
            this.currentMarker.setTitle(place.name);
            if (this.circle) {
              this.circle.setMap(null); // removes from the map
              this.circle = new window.google.maps.Circle({
                map: this.map,
                center: place.geometry.location,
                radius: this.stepOneForm.value.Radius * 1000,
                strokeColor: '#007CFF',
                fillColor: '#007cff33',
                strokeWeight: 1,
              });
            }
            return;
          }

          this.currentMarker = new window.google.maps.Marker({
            map: this.map,
            position: place.geometry.location,
            title: place.name,
            draggable: false,
          });

          this.circle = new window.google.maps.Circle({
            map: this.map,
            center: place.geometry.location,
            radius: this.stepOneForm.value.Radius * 1000,
            strokeColor: '#007CFF',
            fillColor: '#007cff33',
            strokeWeight: 1,
          });

          this.addMarkerListener(this.currentMarker);
        }
      }
    );
  }

    private addMarkerListener(marker: google.maps.Marker): void {
        marker.addListener('dragend', (event: google.maps.MapMouseEvent) => {
            const newLatLng: google.maps.LatLng | null = event.latLng;
            if (!newLatLng) {
                return;
            }
            const newLat = newLatLng?.lat();
            const newLng = newLatLng?.lng();
            this.reverseGeocode(newLat, newLng);
        });
    }

    private reverseGeocode(lat: number, lng: number): void {
        if (!this.geocoder) {
            return;
        }

        const latlng = { lat, lng };

                 this.geocoder.geocode({ location: latlng }, (results, status) => {
             if (status === window.google.maps.GeocoderStatus.OK) {
                 if (results && results[0]) {
                     const formattedAddress = results[0].formatted_address;
                     this.stepOneForm.get('Address')?.setValue(formattedAddress);
                 } else {
                     // No results found for reverse geocoding
                 }
             } else {
                 // Reverse geocoding failed
             }
         });
    }

    private validateDuplicateAddress(chosenAddress: string): boolean {
        if (!this.data?.stores || !this.data.stores.length) {
            return false;
        }

        const isDuplicate = this.data.stores.some(
            ({ Address }) => Address === chosenAddress
        );

        return isDuplicate;
    }

         private setStreetAddressValidator(): void {
         if (!this.data?.stores) {
             return;
         }
         this.stepOneForm
             .get('Address')
             ?.addValidators(duplicateAddressValidator(this.data.stores));
     }
  private filterStreets(value: string): string[] {
    const filterValue = value.toLowerCase();
		return this.streetOptions.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }
  get stepOneForm(): FormGroup {
    return this.createStoreForm.get('stepOne') as FormGroup;
  }

  get stepTwoForm(): FormGroup {
    return this.createStoreForm.get('stepTwo') as FormGroup;
  }

  get stepThreeForm(): FormGroup {
    return this.createStoreForm.get('stepThree') as FormGroup;
  }

    get stepFourForm(): FormGroup {
        return this.createStoreForm.get('stepFour') as FormGroup;
    }

    get stepFiveForm(): FormGroup {
        return this.createStoreForm.get('stepFive') as FormGroup;
    }

 onDragOver(event: DragEvent) {
  event.preventDefault();
  event.stopPropagation();
}

onDragLeave(event: DragEvent) {
  event.preventDefault();
  event.stopPropagation();
}

onFileDrop(event: DragEvent) {
  event.preventDefault();
  const file = event.dataTransfer?.files[0];
  if (file) {
    this.handleFile(file);
  }
}

handleFile(file: File) {
  const reader = new FileReader();
  reader.onload = () => {
    this.stepOneForm.get('ImageUrl')?.setValue(reader.result);
  };
  reader.readAsDataURL(file);
}

removeLocationPhoto(): void {
    this.stepOneForm.get('ImageUrl')?.reset();
  }
private togglePhotoFileValidator(toggle: boolean = true): void {
    if (toggle) {
      return this.locationPhotoFile?.clearValidators();
    }

    return this.locationPhotoFile?.addValidators([
      Validators.required,
      fileUploadValidator(),
    ]);
  }
 get locationPhotoFile(): AbstractControl<File | null, File | null> | null {
      return this.stepOneForm.get('ImageUrl');
    }
onFileSelected(event: Event) {
  const file = (event.target as HTMLInputElement).files?.[0];
  if (file) {
    this.handleFile(file);
  }
}
    onFileUploadSelected(event: Event): void {
      const input = event.target as HTMLInputElement;
      if (input.files && input.files.length > 0) {
        this.selectedFile = input.files[0];
        this.selectedFileName = this.selectedFile.name;
        this.stepTwoForm.patchValue({
            fileupload: this.selectedFile,
        });
        this.stepTwoForm.get('fileupload')?.updateValueAndValidity();
      }
    }
     uploadedFiles: File[] = [];
    get fileNamesDisplay(): string {
        return this.uploadedFiles.map((f) => f.name).join(', ');
    }
    triggerFileInput(): void {
      this.hiddenFileInput.nativeElement.click();
    }

    onMultipleFilesSelected(event: Event): void {
      this.uploadedFiles = [];
      this.filesNames = [];

      const input = event.target as HTMLInputElement;
      if (input.files && input.files.length > 0) {
        const files = Array.from(input.files);

        for (const file of files) {
          if (!file.name.toLowerCase().endsWith('.xlsx')) {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: `File ${file.name} has invalid file format. Only .xlsx files are allowed.` });
              return;
          }

          if (file.size > 50 * 1024 * 1024) { // 50MB
              this.messageService.add({ severity: 'error', summary: 'Error', detail: `File ${file.name} is too big. Max size: 50MB.` });
              return;
          }
        }

        this.uploadedFiles = [...this.uploadedFiles, ...files];
        // Update form
        this.stepTwoForm.patchValue({ fileupload: this.uploadedFiles });
        this.stepTwoForm.get('fileupload')?.updateValueAndValidity();
        this.filesNames = [];
        this.uploadedFiles.map((f) => this.filesNames.push(f.name));

        this.formData = new FormData();
        this.formData.append('file', input.files[0]);
        this.formData.append('storeType', this.stepOneForm.value.StoreType);

        this.validateNewProductsFile();
      }
    }

    downloadFile(index: number): void {
      const file = this.uploadedFiles[index];
      const reader = new FileReader();
      reader.onload = () => {
        const csvContent = reader.result as string;
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = file.name || `download${index + 1}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      };
      reader.readAsText(file);
    }

	showModal(): void {
		const dialogRef = this.dialog.open(StoreOperationHoursDialogComponent, {
			width: '900px',
			panelClass: 'storeTimeDialog',
			data: {
				savedHours: [], // Initialize with empty array for new entries
				savedOperationHours: this.savedOperationHours,
				existingOperationHours: this.savedOperationHours,
			},
        });

		dialogRef.afterClosed().subscribe((result) => {
			if (result) {
				// Handle the new data structure with both time ranges and selected days
				if (result.timeRanges && result.selectedDays) {
					// Create a new operating hours entry
					const newEntry: OperatingHoursEntry = {
						selectedDays: result.selectedDays,
						timeRanges: result.timeRanges
                    };

					// Add to the array
					this.savedOperationHours.push(newEntry);
					this.stepThreeForm.patchValue({ operationHours: this.savedOperationHours });
				} else {
					// Fallback for old data structure
					const newEntry: OperatingHoursEntry = {
						selectedDays: [],
						timeRanges: result
					};
					this.savedOperationHours.push(newEntry);
					this.stepThreeForm.patchValue({ operationHours: this.savedOperationHours });
				}
			}
      });
    }

	editOperationHours(entryIndex: number): void {
		const entry = this.savedOperationHours[entryIndex];
		// Get existing operation hours excluding the current entry being edited
		const existingOperationHours = this.savedOperationHours.filter((_, index) => index !== entryIndex);

		const dialogRef = this.dialog.open(EditOperationHoursComponent, {
        width: '900px',
        panelClass: 'storeTimeDialog',
        data: {
                    savedOperationHours: entry.timeRanges,
                    savedSelectedDays: entry.selectedDays,
                    existingOperationHours,
                },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
            // Handle the new data structure with both time ranges and selected days
            if (result.timeRanges && result.selectedDays) {
                // Update the specific entry
                this.savedOperationHours[entryIndex] = {
                    selectedDays: result.selectedDays,
                    timeRanges: result.timeRanges
                };
                this.stepThreeForm.patchValue({ operationHours: this.savedOperationHours });
            }
        }
      });
    }

	removeOperationHours(entryIndex: number): void {
		if (this.savedOperationHours.length > 1) {
			this.savedOperationHours.splice(entryIndex, 1);
			this.stepThreeForm.patchValue({ operationHours: this.savedOperationHours });
		}
	}

   onStepOneSubmit(): void {
        this.submitted = true;
        if (this.stepOneForm.valid) {
          this.stepper.next();
        }
   }

    onNextStep(): void {
     if (this.stepper.selectedIndex === 0) {
       this.submitted = true;
       if (this.stepOneForm.valid) {
         this.stepper.next();
       }
     } else if (this.stepper.selectedIndex === 2) {
         this.stepper.next();
         const inputs = document.querySelectorAll<HTMLInputElement>('[required]');
         inputs.forEach(input => {
             input.dispatchEvent(new Event('focusout'));
         });
     }
     else {
       this.stepper.next();
     }
   }
   onImageError(event: any): void {
     this.messageService.add({
       severity: 'warn',
       summary: 'Image Error',
       detail: 'Failed to load the uploaded image. Please try uploading again.',
     });
   }

  finish(): void {
   const stepOne = this.stepOneForm.value;
   const stepTwo = this.stepTwoForm.value;
   const stepThree = this.stepThreeForm.value;
   const stepFour = this.stepFourForm.value;
   const stepFive = this.stepFiveForm.value;
   this.submitted = true;
   if (this.createStoreForm.invalid) {
     return;
   }

   this.showConfirmCreation = false;
   this.createStore();
  }

    goBack() {
        if (this.stepper.selectedIndex === 3) {
            this.modalTitle = 'Create New Store';
        }

        this.stepper.previous();
    }

    validateNewProductsFile() {
        this.loading = true;
        this.productService.validateProductXls(this.formData, this.messageService)
            .then(data => {
                this.loading = false;
                if (!data.Success) {
                    this.productFileValid = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.productFileValid = true;
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'File successfully attached.' });
            })
            .catch((error) => {
                this.loading = false;
                this.productFileValid = false;
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.message || 'An error occurred while validating products.',
                });
                throw error;
            });
    }

    uploadProductsFromExcel(newStoreData: any) {
        if (!newStoreData.Id) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to upload products. StoreId = 0' });
            return;
        }
        if (!newStoreData.MerchantId) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to upload products. MerchantId = 0' });
            return;
        }

        this.loading = true;
        this.formData.append('storeId', newStoreData.Id);
        this.formData.append('merchantId', newStoreData.MerchantId);
        this.formData.append('storeType', newStoreData.StoreType);

        this.productService.uploadProductXlsToDb(this.formData, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage || 'Failed to upload products.' });
                    return;
                }

                this.loading = false;
                this.messageService.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Products uploaded successfully!',
                });
            })
            .catch((error) => {
				this.loading = false;
				this.messageService.add({
					severity: 'error',
					summary: 'Error',
					detail: error.message || 'An error occurred while uploading products.',
				});
				throw error;
			});
    }

    changeStoreType(event: any) {
        this.storeTypeText = event.value === MerchantTypeEnum.Eats ? 'Eats' : 'Marts';
    }

    goToPreview() {
        const stepOne = this.stepOneForm.value;
        if (!stepOne.ImageUrl) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Please upload a store image.',
            });
            return;
        }

        // Validate operating hours before proceeding
        if (this.savedOperationHours && this.savedOperationHours.length > 0) {
            const validation = this.validateOperatingHours(this.savedOperationHours);
            if (!validation.isValid) {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Validation Error',
                    detail: `Operating hours validation failed: ${validation.errors.join(', ')}`,
                });
                return;
            }
        }

        // Map form data to CreateStoreRequestDto structure
        this.createStoreDto = {
            Name: stepOne.StoreName,
            Brand: stepOne.brand,
            Email: stepOne.StoreEmailAddress,
            Phone: stepOne.StorePhoneNumber,
            Address: stepOne.Address.description,
            AddressDetails: stepOne.addDetails,
            Lat: this.lat,
            Long: this.long,
            LocationTypeId: parseInt(stepOne.locType, 10) || 0,
            StoreType: stepOne.StoreType,
            ImageUrl: stepOne.ImageUrl,
            City: stepOne.City,
            ServiceableAreaRadius: stepOne.Radius,
            PostalCode: stepOne.PostalCode,
            StoreOperationHours: this.savedOperationHours?.flatMap(entry =>
                entry.selectedDays.map(day =>
                    entry.timeRanges
                        .map(timeRange => {
                            const formattedRange = this.safeFormatTimeRangeForBackend(timeRange);
                            if (formattedRange) {
                                return {
                                    DayOfWeek: this.getDayOfWeekNumber(day),
                                    StartTime: formattedRange.StartTime,
                                    EndTime: formattedRange.EndTime
                                };
                            }
                            return null;
                        })
                        .filter(hour => hour !== null)
                ).flat()
            ) || [],
            StoreSpecialHours: this.saveSpecialHours?.map(specialHour => ({
                Title: specialHour.description,
                StartDate: specialHour.startDate,
                EndDate: specialHour.endDate,
                IsOpen: specialHour.availability,
                StoreSpecialHourTimes: specialHour.timeRanges?.map((timeRange: TimeRange) => {
                    const startTime = this.convertTimeRangeToDateTime(timeRange, 'start');
                    const endTime = this.convertTimeRangeToDateTime(timeRange, 'end');
                    return {
                        OpensAt: startTime,
                        ClosesAt: endTime
                    };
                }) || []
            })) || [],
            MerchantId: this.stepFourForm.value.MerchantId,
            Commission: this.stepFourForm.value.Commission,
            PromoAdvertisingBudget: this.stepFourForm.value.PromoAdvertisingBudget === 'Coming Soon' ? 0 : this.stepFourForm.value.PromoAdvertisingBudget,
            MinimalOrderAmount: this.stepFourForm.value.MinimalOrderAmount,
            MinimalOrderFee: this.stepFourForm.value.MinimalOrderFee,
            TimeZoneOffSet: Utils.getTimezoneOffset(),
            PreperationTime: this.stepFourForm.value.PreparationTime,
        };

        // Validate that all required time formatting succeeded
        const hasInvalidTimes = this.createStoreDto.StoreOperationHours.some((hour: StoreOperationHourDto) =>
            !hour.StartTime || !hour.EndTime || hour.StartTime === '' || hour.EndTime === ''
        );

        if (hasInvalidTimes) {
            this.messageService.add({
                severity: 'error',
                summary: 'Time Format Error',
                detail: 'Some operating hours could not be formatted correctly. Please check and fix the time entries.',
            });
            return;
        }

        this.getOperationHoursForPreview();
        this.modalTitle = 'Preview Store';
    }

    getOperationHoursForPreview() {
        const dayOrder = ['Sun', 'Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat'];

        this.previewOperationHours = [];

        for (const operationHour of this.savedOperationHours) {
            let hourForPreview = '';

            if (operationHour.selectedDays && operationHour.selectedDays.length > 0) {
                const sortedDays = [...operationHour.selectedDays].sort(
                    (a, b) => dayOrder.indexOf(a) - dayOrder.indexOf(b)
                );

                const groups: string[] = [];
                let start = sortedDays[0];
                let prev = sortedDays[0];

                for (let i = 1; i < sortedDays.length; i++) {
                    const current = sortedDays[i];
                    const prevIndex = dayOrder.indexOf(prev);
                    const currIndex = dayOrder.indexOf(current);

                    if (currIndex === prevIndex + 1) {
                        prev = current;
                    } else {
                        if (start === prev) {
                            groups.push(start);
                        } else {
                            groups.push(`${start} - ${prev}`);
                        }
                        start = current;
                        prev = current;
                    }
                }

                if (start === prev) {
                    groups.push(start);
                } else {
                    groups.push(`${start} - ${prev}`);
                }

                hourForPreview += groups.join(', ');
            }

            if (operationHour.timeRanges && operationHour.timeRanges.length > 0) {
                hourForPreview += '  |  ';
                for (const timeRange of operationHour.timeRanges) {
                    hourForPreview += timeRange.startTime + ' - ' + timeRange.endTime + ', ';
                }
                hourForPreview = hourForPreview.slice(0, -2);
            }

            this.previewOperationHours.push(hourForPreview);
        }
    }

  createStore(): void {
    this.loading = true;

		this.storeService
			.createStore(this.createStoreDto, this.messageService)
			.then((data) => {
        if (!data) {
          this.loading = false;
          return;
        }

        if (!data.Success) {
          this.loading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: data.ErrorMessage || 'Failed to create store.',
          });
          return;
        }

        this.uploadProductsFromExcel(data);

        this.loading = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Store created successfully!',
        });
        // Close dialog with the created store data
        this.dialogRef.close(data);
      })
        .catch((error) => {
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error.message || 'An error occurred while creating the store.',
        });
        throw error;
      });
  }

	// Helper method to convert day name to day of week number
	getDayOfWeekNumber(dayName: string): number {
		const dayMap: { [key: string]: number } = {
			Sun: 0,
			Mon: 1,
			Tue: 2,
			Wed: 3,
			Thur: 4,
			Fri: 5,
			Sat: 6
		};
		return dayMap[dayName] || 0;
}

	// Helper method to format time range for display
	getFormattedTimeRange(entryIndex: number = 0): string {
		if (this.savedOperationHours.length === 0 || !this.savedOperationHours[entryIndex]) {
			return 'No hours set';
		}

		// Get all time ranges from the specified entry
		const entry = this.savedOperationHours[entryIndex];
		if (!entry || !entry.timeRanges || entry.timeRanges.length === 0) {
			return 'No hours set';
		}

		// Format all time ranges with validation
		const formattedRanges = entry.timeRanges
			.filter(range =>
				// Filter out invalid time ranges
				 range &&
					   typeof range.hour === 'number' &&
					   typeof range.minute === 'number' &&
					   typeof range.endHour === 'number' &&
					   typeof range.endMinute === 'number' &&
					   range.period &&
					   range.endPeriod
			)
			.map(range => {
				const startTime = this.formatTime(range.hour, range.minute, range.period);
				const endTime = this.formatTime(range.endHour, range.endMinute, range.endPeriod);

				// Only include valid formatted times
				if (startTime !== 'Invalid time' && endTime !== 'Invalid time') {
					return `${startTime} - ${endTime}`;
				}
				return null;
			})
			.filter(timeRange => timeRange !== null); // Remove invalid ranges

		if (formattedRanges.length === 0) {
			return 'No valid hours set';
		}

		// Join multiple ranges with line breaks or commas
		return formattedRanges.join(', ');
	}

	/**
	 * Validates the entire operating hours structure before sending to backend
	 * Supports both regular business hours and overnight schedules (e.g., 11:00 PM to 2:00 AM)
	 * @param operationHours - The operating hours array to validate
	 * @returns Object with validation result and any error messages
	 */
	validateOperatingHours(operationHours: OperatingHoursEntry[]): { isValid: boolean; errors: string[] } {
		const errors: string[] = [];

		if (!operationHours || !Array.isArray(operationHours)) {
			errors.push('Operating hours must be an array');
			return { isValid: false, errors };
		}

		if (operationHours.length === 0) {
			errors.push('At least one operating hours entry is required');
			return { isValid: false, errors };
		}

		operationHours.forEach((entry, index) => {
			if (!entry) {
				errors.push(`Entry ${index + 1}: Entry is null or undefined`);
				return;
			}

			if (!entry.selectedDays || !Array.isArray(entry.selectedDays) || entry.selectedDays.length === 0) {
				errors.push(`Entry ${index + 1}: No days selected`);
			}

			if (!entry.timeRanges || !Array.isArray(entry.timeRanges) || entry.timeRanges.length === 0) {
				errors.push(`Entry ${index + 1}: No time ranges defined`);
				return;
			}

			entry.timeRanges.forEach((timeRange, timeIndex) => {
				if (!timeRange) {
					errors.push(`Entry ${index + 1}, Time Range ${timeIndex + 1}: Time range is null or undefined`);
					return;
				}

				// Validate time range properties
				if (typeof timeRange.hour !== 'number' || timeRange.hour < 1 || timeRange.hour > 12) {
					errors.push(`Entry ${index + 1}, Time Range ${timeIndex + 1}: Invalid start hour: ${timeRange.hour}`);
				}

				if (typeof timeRange.minute !== 'number' || timeRange.minute < 0 || timeRange.minute > 59) {
					errors.push(`Entry ${index + 1}, Time Range ${timeIndex + 1}: Invalid start minute: ${timeRange.minute}`);
				}

				if (typeof timeRange.endHour !== 'number' || timeRange.endHour < 1 || timeRange.endHour > 12) {
					errors.push(`Entry ${index + 1}, Time Range ${timeIndex + 1}: Invalid end hour: ${timeRange.endHour}`);
				}

				if (typeof timeRange.endMinute !== 'number' || timeRange.endMinute < 0 || timeRange.endMinute > 59) {
					errors.push(`Entry ${index + 1}, Time Range ${timeIndex + 1}: Invalid end minute: ${timeRange.endMinute}`);
				}

				if (!timeRange.period || !['AM', 'PM', 'am', 'pm'].includes(timeRange.period)) {
					errors.push(`Entry ${index + 1}, Time Range ${timeIndex + 1}: Invalid start period: ${timeRange.period}`);
				}

				if (!timeRange.endPeriod || !['AM', 'PM', 'am', 'pm'].includes(timeRange.endPeriod)) {
					errors.push(`Entry ${index + 1}, Time Range ${timeIndex + 1}: Invalid end period: ${timeRange.endPeriod}`);
				}

				// Validate that end time is after start time, accounting for overnight schedules
				const startTime = this.convertTo24Hour(timeRange.hour, timeRange.period);
				const endTime = this.convertTo24Hour(timeRange.endHour, timeRange.endPeriod);

				// Handle overnight schedules (e.g., 11:00 PM to 2:00 AM)
				// If end time is less than start time, it means the business is open overnight
				// This is valid for businesses like bars, clubs, or 24-hour establishments
				const overnightValidation = this.validateOvernightSchedule(startTime, endTime);

				// For overnight schedules, we need to ensure the end time is not the same as start time
				// and that the schedule makes logical sense (e.g., not 12:00 AM to 12:00 AM)
				if (startTime === endTime) {
					errors.push(`Entry ${index + 1}, Time Range ${timeIndex + 1}: Start time and end time cannot be the same`);
				}

			});
		});

		return { isValid: errors.length === 0, errors };
	}

	/**
	 * Converts 12-hour time to 24-hour time for comparison
	 * @param hour - Hour in 12-hour format (1-12)
	 * @param period - AM or PM
	 * @returns Hour in 24-hour format (0-23)
	 */
	private convertTo24Hour(hour: number, period: string): number {
		if (period.toUpperCase() === 'PM' && hour !== 12) {
			return hour + 12;
		} else if (period.toUpperCase() === 'AM' && hour === 12) {
			return 0;
		}
		return hour;
	}

	/**
	 * Validates if a time range represents a valid overnight schedule
	 * @param startHour - Start hour in 24-hour format
	 * @param endHour - End hour in 24-hour format
	 * @returns Object with validation result and description
	 */
	private validateOvernightSchedule(startHour: number, endHour: number): { isValid: boolean; description: string } {
		// Overnight schedule: end time is less than start time (e.g., 23:00 to 02:00)
		if (endHour < startHour) {
			// Common overnight business hours validation
			// Most overnight businesses close between 1:00 AM and 6:00 AM
			if (endHour >= 1 && endHour <= 6) {
				return {
					isValid: true,
					description: 'Overnight schedule (closes early morning)'
				};
			}
			// For very late night closures (after 6:00 AM), provide a warning but allow
			if (endHour > 6) {
				return {
					isValid: true,
					description: 'Extended overnight schedule (closes late morning)'
				};
			}
		}

		// Regular schedule: end time is after start time
		return {
			isValid: true,
			description: 'Regular business hours'
		};
	}

	/**
	 * Handles edge cases in time validation and provides user-friendly error messages
	 * @param timeString - The time string to validate
	 * @returns Object with validation result and suggestions
	 */
	validateTimeWithSuggestions(timeString: string): { isValid: boolean; suggestions: string[] } {
		const suggestions: string[] = [];

		if (!timeString || typeof timeString !== 'string') {
			suggestions.push('Time string must be provided');
			return { isValid: false, suggestions };
		}

		const trimmedTime = timeString.trim();

		// Check for common formatting issues
		if (trimmedTime.includes('.')) {
			suggestions.push('Remove decimal points from time format');
		}

		if (trimmedTime.includes('-')) {
			suggestions.push('Use colon (:) instead of dash (-) to separate hours and minutes');
		}

		if (trimmedTime.includes('am') || trimmedTime.includes('pm')) {
			suggestions.push('Use uppercase AM/PM format');
		}

		if (!trimmedTime.includes(':')) {
			suggestions.push('Use colon (:) to separate hours and minutes');
		}

		if (!trimmedTime.includes('AM') && !trimmedTime.includes('PM')) {
			suggestions.push('Include AM or PM period indicator');
		}

		const isValid = this.isValidTimeFormat(trimmedTime);
		return { isValid, suggestions };
	}

	formatTime(hour: number, minute: number, period: string): string {
		// Validate inputs
		if (typeof hour !== 'number' || isNaN(hour) || hour < 1 || hour > 12) {
			return 'Invalid time';
		}

		if (typeof minute !== 'number' || isNaN(minute) || minute < 0 || minute > 59) {
			return 'Invalid time';
		}

		if (!period || typeof period !== 'string' || !['AM', 'PM', 'am', 'pm'].includes(period)) {
			return 'Invalid time';
		}

		const formattedHour = hour.toString().padStart(2, '0');
		const formattedMinute = minute.toString().padStart(2, '0');
		return `${formattedHour}:${formattedMinute} ${period.toUpperCase()}`;
	}

		// Helper method to format time for backend API using moment.js (follows existing codebase pattern)
	formatTimeForBackend(timeString: string): string {
		// Input validation
		if (!timeString || typeof timeString !== 'string') {
			return '';
		}

		const trimmedTime = timeString.trim();
		if (trimmedTime.length === 0) {
			return '';
		}

		// Check if timeString is already in ISO format (YYYY-MM-DDTHH:mm:ss or similar)
		// Use a more specific regex to validate ISO format
		const isoTimeRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/;
		if (isoTimeRegex.test(trimmedTime)) {
			// Validate the ISO format more thoroughly
			try {
				const parsedDate = new Date(trimmedTime);
				if (isNaN(parsedDate.getTime())) {
					return '';
				}
				return trimmedTime;
			} catch (error) {
				return '';
			}
		}

		// Parse 12-hour format: "H:MM AM/PM" or "HH:MM AM/PM"
		// More flexible regex that handles various spacing and case
		const timeRegex = /^(\d{1,2}):(\d{2})\s*(AM|PM|am|pm)$/;
		const match = trimmedTime.match(timeRegex);

		if (!match) {
			return '';
		}

		try {
			const hours = parseInt(match[1], 10);
			const minutes = parseInt(match[2], 10);
			const period = match[3].toUpperCase();

			// Comprehensive validation of hours and minutes
			if (hours < 1 || hours > 12) {
				return '';
			}

			if (minutes < 0 || minutes > 59) {
				return '';
			}

			// Convert to 24-hour format
			let hour24 = hours;
			if (period === 'PM' && hours !== 12) {
				hour24 = hours + 12;
			} else if (period === 'AM' && hours === 12) {
				hour24 = 0;
			}

			// Create a date object for today with the validated time
			const today = new Date();
			today.setHours(hour24, minutes, 0, 0);

			// Validate the resulting date
			if (isNaN(today.getTime())) {
				return '';
			}

			// Use moment.js to format following the existing codebase pattern
			const formattedTime = moment(today).format('YYYY-MM-DDTHH:mm:ss');

			// Final validation of the formatted output
			if (!formattedTime || formattedTime === 'Invalid date') {
				return '';
			}

			return formattedTime;
		} catch (error) {
			return '';
		}
	}

	/**
	 * Validates if a time string is in a valid format
	 * @param timeString - The time string to validate
	 * @returns true if valid, false otherwise
	 */
	isValidTimeFormat(timeString: string): boolean {
		if (!timeString || typeof timeString !== 'string') {
			return false;
		}

		const trimmedTime = timeString.trim();
		if (trimmedTime.length === 0) {
			return false;
		}

		// Check ISO format first
		const isoTimeRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/;
		if (isoTimeRegex.test(trimmedTime)) {
			try {
				const parsedDate = new Date(trimmedTime);
				return !isNaN(parsedDate.getTime());
			} catch {
				return false;
			}
		}

		// Check 12-hour format
		const timeRegex = /^(\d{1,2}):(\d{2})\s*(AM|PM|am|pm)$/;
		const match = trimmedTime.match(timeRegex);
		if (!match) {
			return false;
		}

		const hours = parseInt(match[1], 10);
		const minutes = parseInt(match[2], 10);

		return hours >= 1 && hours <= 12 && minutes >= 0 && minutes <= 59;
	}

	/**
	 * Safely formats time for display, with fallback for invalid inputs
	 * @param timeString - The time string to format
	 * @returns Formatted time string or fallback message
	 */
	safeFormatTimeForDisplay(timeString: string): string {
		if (this.isValidTimeFormat(timeString)) {
			return timeString;
		}
		return 'Invalid time format';
	}

	/**
	 * Safely formats a time range for backend with comprehensive validation
	 * @param timeRange - The time range object to format
	 * @returns Formatted time range or null if invalid
	 */
	safeFormatTimeRangeForBackend(timeRange: TimeRange): { StartTime: string; EndTime: string } | null {
		if (!timeRange) {
			return null;
		}

		// Validate time range structure
		if (typeof timeRange.hour !== 'number' || typeof timeRange.minute !== 'number' ||
			typeof timeRange.endHour !== 'number' || typeof timeRange.endMinute !== 'number' ||
			!timeRange.period || !timeRange.endPeriod) {
			return null;
		}

		// Format start and end times
		const startTime = this.formatTimeForBackend(this.formatTime(timeRange.hour, timeRange.minute, timeRange.period));
		const endTime = this.formatTimeForBackend(this.formatTime(timeRange.endHour, timeRange.endMinute, timeRange.endPeriod));

		// Validate formatted times
		if (!startTime || !endTime || startTime === '' || endTime === '') {
			return null;
		}

		return { StartTime: startTime, EndTime: endTime };
	}

	getProductsTemplate() {
		this.loading = true;
        const dto = {
            StoreType: this.stepOneForm.value.StoreType
        };
		this.productService
			.downloadProductsTemplate(dto)
			.subscribe({
				next: (data) => {
					this.loading = false;
					const fileName = 'Products Template';
					const blob: Blob = data.body as Blob;

					if (!data.ok) {
						this.messageService.add({
							severity: 'error',
							summary: 'Error',
							detail: data.ErrorMessage || 'Failed to download products template.',
						});
						return;
					}
					const a = document.createElement('a');
					a.download = fileName;
					a.href = window.URL.createObjectURL(blob);
					a.click();
					a.remove();
				},
				error: (err) => {
					this.loading = false;
					let errorMessage = 'An error occurred while downloading the products template.';

					// Since API always returns 200, check for error content
					if (err.error && err.error.ErrorMessage) {
						errorMessage = err.error.ErrorMessage;
					} else if (err.message) {
						errorMessage = err.message;
					} else if (!navigator.onLine) {
						errorMessage = 'Network error. Please check your connection and try again.';
					}

					this.messageService.add({
						severity: 'error',
						summary: 'Error',
						detail: errorMessage,
					});
				},
			});
	}

	removeUploadProductTemplate(index: number) {
		this.uploadedFiles.splice(index, 1);
		this.filesNames.splice(index, 1);

		// Update form control to maintain state consistency
		this.stepTwoForm.patchValue({ fileupload: this.uploadedFiles });
		this.stepTwoForm.get('fileupload')?.updateValueAndValidity();
        this.productFileValid = false;

		// Clear file input cache using ViewChild reference
		// To allow user to upload temp file again
		if (this.hiddenFileInput && this.uploadedFiles.length === 0) {
			this.hiddenFileInput.nativeElement.value = '';
		}
	}

	openAddSpecialHoursDialog(){
		// Extract existing special hours date ranges to pass to dialog
		const existingDateRanges = this.saveSpecialHours.map(specialHour => ({
			startDate: specialHour.startDate,
			endDate: specialHour.endDate
		}));

		const ref = this.dialog.open(AddSpecialHoursDialogComponent,{
			width:'1000px',
			data: {
				existingSpecialHours: existingDateRanges
			}
		});

		ref.afterClosed().subscribe(result => {
			if (result) {
				// Create a new special hours entry
				const specialHoursEntry: specialHoursEntry = {
					availability: result.availability,
					timeRanges: result.timeRanges,
					open24hrs: result.open24hrs,
					startDate: result.startDate,
					endDate: result.endDate,
					description: result.description
				};

				// Add to the saveSpecialHours array
				this.saveSpecialHours.push(specialHoursEntry);
			}
		});
	}

	  removeSpecialHours(index: number) {
    this.saveSpecialHours.splice(index, 1);
  }

  editSpecialHours(index: number) {
    const specialHourToEdit = this.saveSpecialHours[index];

    // Extract existing special hours date ranges excluding the current item being edited
    const existingDateRanges = this.saveSpecialHours
      .filter((_, i) => i !== index) // Exclude current item
      .map(specialHour => ({
        startDate: specialHour.startDate,
        endDate: specialHour.endDate
      }));

    const ref = this.dialog.open(EditSpecialHoursDialogComponent, {
      width: '1000px',
      data: {
        ...specialHourToEdit,
        existingSpecialHours: existingDateRanges
      }
    });

    ref.afterClosed().subscribe(result => {
      if (result) {
        // Update the existing special hours entry
        this.saveSpecialHours[index] = result;
      }
    });
  }

	onEditPreparationTime() {
		const dialogRef = this.dialog.open(PreparationHoursComponent, {
    data: { prepTimeValue: this.prepTimeValue, prepTimeValueInt: this.prepTimeValueInt }
	});
	 dialogRef.afterClosed().subscribe(result => {
    if (result) {
      this.prepTimeValue = result.prepTimeValue;
      this.prepTimeValueInt = result.prepTimeValueInt;
      // Update the form control with the new numeric value
      this.stepFourForm.get('PreparationTime')?.setValue(this.prepTimeValueInt);
    }
  });
	}

  formatSpecialHoursDateRange(startDate: Date, endDate: Date): string {
    if (!startDate || !endDate) {
      return '';
    }

    // Check if dates are the same
    if (startDate.getTime() === endDate.getTime()) {
      return this.formatDate(startDate);
    }

    // Format both dates
    return `${this.formatDate(startDate)} - ${this.formatDate(endDate)}`;
  }

  private formatDate(date: Date): string {
    const months = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];

    const month = months[date.getMonth()];
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${month} ${day}, ${year}`;
  }

  private convertTimeRangeToDateTime(timeRange: TimeRange, type: 'start' | 'end'): Date {
    let timeString: string;

    if (type === 'start') {
      timeString = timeRange.startTime;
    } else {
      timeString = timeRange.endTime;
    }

    // Parse the time string (e.g., "09:00 AM" or "05:00 PM")
    const timeMatch = timeString.match(/(\d+):(\d+)\s*(AM|PM)/);
    if (!timeMatch) {
      return new Date();
    }

    const hour = parseInt(timeMatch[1], 10);
    const minute = parseInt(timeMatch[2], 10);
    const period = timeMatch[3].toUpperCase();

    // Validate inputs
    if (hour < 1 || hour > 12 || minute < 0 || minute > 59) {
      return new Date();
    }

    // Convert 12-hour format to 24-hour format
    let hour24 = hour;
    if (period === 'PM' && hour !== 12) {
      hour24 = hour + 12;
    } else if (period === 'AM' && hour === 12) {
      hour24 = 0;
    }

    // Create a date object with the time using UTC to avoid timezone issues
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
    const day = today.getDate();

    // Create date with the specific time using UTC
    const date = new Date(Date.UTC(year, month, day, hour24, minute, 0, 0));

    return date;
  }
}
